export default __webpack_public_path__ + "static/media/mxmChoc.9138823d.png";